import { ErrorBoundary } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { useRepositoryMetaTitle } from "../app/routing"
import { preloadRepository } from "../app/services/repository"
import { preloadProfile } from "../app/services/user"
import { DocumentListBody } from "./DocumentListBody"
import {
  DocumentListBodyLayout,
  DocumentListSkeleton,
  renderDocumentListError
} from "./DocumentListBody/DocumentListBody"
import { DocumentListHeader } from "./DocumentListHeader/DocumentListHeader"
import { DocumentListLayout } from "./documentListLayout"
import { DocumentListSidePanel } from "./DocumentListSidePanel"
import { DocumentListProvider } from "./useDocumentList"

interface DocumentListProps {
  tab: "working" | "archived"
}

export function DocumentList(props: DocumentListProps) {
  const { tab } = props

  useRepositoryMetaTitle(tabToLabel[tab])

  preloadRepository()
  preloadProfile()

  return (
    <DocumentListProvider>
      <DocumentListLayout
        header={<DocumentListHeader tab={tab} />}
        body={
          <DocumentListBodyLayout>
            <ErrorBoundary renderError={renderDocumentListError}>
              <Suspense fallback={<DocumentListSkeleton tab={tab} />}>
                <DocumentListBody tab={tab} />
              </Suspense>
            </ErrorBoundary>
          </DocumentListBodyLayout>
        }
        sidePanel={<DocumentListSidePanel selectedMenuItem="main-space" />}
      />
    </DocumentListProvider>
  )
}

const tabToLabel: Record<DocumentListProps["tab"], string> = {
  working: "Work",
  archived: "Archived"
}
